import { Button, Form, message, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { IoMdSend } from "react-icons/io";
import { get, post } from "../../../apiService";
import TextArea from "antd/es/input/TextArea";
import { MdDownload } from "react-icons/md";
import header from "../../../Assets/header.png";
import footer from "../../../Assets/footer.png";
import jsPDF from "jspdf";
import "jspdf-autotable"; // Import the autoTable plugin for tables
import moment from "moment/moment";
import { getProfile } from "../../../services/localStorageServices";
import { FaCartShopping } from "react-icons/fa6";
import * as XLSX from "xlsx"; // Import the xlsx library

export default function QuoateSendModal({
  cartValue,
  setCartValue,
  orderSubTotal,
  delivery,
  finalAmount,
  totalWeight,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState({ search: "", type: "" });
  const [form] = Form.useForm();
  const [selectedStaff, setSelectedstaff] = useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [selectedUserDetail, setSelectedUserDetail] = useState({});
  const { profile } = getProfile();
  const [downloadType, setDownloadType] = useState("pdf");
  const [textMessage, setTextMessage] = useState("");

  const column = [
    { title: "Avg Weight", dataIndex: "avg_wt", key: "avg_wt" },
    { title: "Sieve", dataIndex: "sieve", key: "sieve" },
    { title: "Size (MM)", dataIndex: "diam_mm", key: "diam_mm" },
    { title: "Colour", dataIndex: "color", key: "color" },
    { title: "Shade", dataIndex: "shade", key: "shade" },
    { title: "Cut", dataIndex: "cut", key: "cut" },
    { title: "Clarity", dataIndex: "clarity", key: "clarity" },
    { title: "Price", dataIndex: "price", key: "price" },
    // { title: "Type", dataIndex: "typeSelect", key: "typeSelect" },
    // { title: "Selected Type", dataIndex: "updateCarat", key: "updateCarat" },
    { title: "Total Weight", dataIndex: "total_weight", key: "total_weight" },
    { title: "Value", dataIndex: "updatedPrice", key: "updatedPrice" },
  ];

  const fetchStaff = async (search, type) => {
    if (type !== "") {
      setLoading(true);
      try {
        const action = "fetch";
        let referBy = false;
        if (type === "user") {
          referBy =
            profile.type === "staff"
              ? profile.user_id
              : staffList.find((value) => value.name === selectedStaff)
                  ?.user_id;
        }

        const response = await get(
          `/user.php?action=${action}&limit=10&page=1&type=${type}${
            search !== "" ? "&search=" + search : ""
          }${referBy ? "&refer_by=" + referBy : ""}`
        );
        if (type === "staff") {
          setStaffList(response.list);
        } else {
          setUserList(response.list);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchStaff(searchData?.search, searchData?.type);
    }, 300);

    return () => clearTimeout(dbounce);
  }, [searchData?.search, searchData?.type]);

  const handleSubmitQuote = () => {
    form.submit();
  };

  const onFinish = async (value) => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("type", value.type);
      formData.append("status", "cart");
      formData.append("user_id", selectedUser);
      formData.append("total", finalAmount);
      formData.append("subtotal", orderSubTotal);
      formData.append("shipping_charge", delivery);
      formData.append("totalWeight", totalWeight);
      formData.append(
        "staff_id",
        profile.type === "staff"
          ? profile.user_id
          : staffList.find((value) => value.name === selectedStaff)?.user_id
      );
      formData.append("message", value.message);
      formData.append(
        "product_list",
        JSON.stringify(
          cartValue.map((value) => ({
            avg_wt: value.avg_wt,
            sieve_sizes: value.sive_sizes,
            diam_mm: value.diam_mm,
            selected_type:
              value.typeSelect === "Carat"
                ? value.updateCarat
                : value.updatePice,
            product_type: value.typeSelect,
            price: value.price,
            color: value.color,
            shade: value.shade,
            clarity: value.clarity,
            cut: value.cut,
            total_weight: value.total_weight,
            product_id: value.product_id,
            subtotal: value.updatedPrice,
          }))
        )
      );
      formData.append("action", "mail");

      const resp = await post("/cart.php", formData);

      if (resp) {
        setLoading(false);

        form.resetFields();
        setIsModalOpen(false);
        setCartValue([]);
        message.success("Quotation Sent Successfully");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleQuoate = () => {
    if (cartValue.length > 0) {
      setIsModalOpen(true);
    } else {
      message.error("No data into cart");
    }
  };

  // ============================= Excel File Export ====================

  const exportPdf = () => {
    const data = form.getFieldsValue();

    if (data.user) {
      setLoading(true);

      const doc = new jsPDF();

      // Load your images
      const headerImage = new Image();
      // const footerImage = new Image();
      headerImage.src = header; // Replace with your image path
      // footerImage.src = footer; // Replace with your image path

      // Define margins
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;
      const headerHeight = 220;

      // Add Header with Image
      const addHeader = () => {
        doc.addImage(headerImage, "PNG", 10, 10, 190, headerHeight); // Adjust dimensions and position as needed
        doc.setLineWidth(0.5);
        doc.line(10, 43, pageWidth - 10, 43); // Horizontal line below the header
      };

      // // Add Footer with Image
      // const addFooter = () => {
      //   doc.addImage(footerImage, "PNG", 10, pageHeight - 210, 190, 200); // Adjust dimensions and position as needed
      //   doc.setTextColor(150);
      //   doc.text(``, pageWidth - 20, pageHeight - 10); // Right-aligned page number
      // };

      // Custom Design Before Table
      const addCustomDesignBeforeTable = () => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        doc.setLineWidth(0.5);
        doc.text("Name : " + selectedUserDetail.name, 10, 50); // Additional information
        doc.text("Number : " + selectedUserDetail.number, 10, 60); // Custom date
        doc.text("Date : " + moment(new Date()).format("DD MMM YYYY"), 140, 50); // Custom date
        // doc.text("Country of Supply : " + selectedUserDetail.state, 140, 60); // Custom date
        // doc.text("Place of Supply : " + selectedUserDetail.city, 140, 70); // Custom date
      };

      // Custom Design After Table
      const addCustomDesignAfterTable = (startY) => {
        // doc.setLineWidth(0.5);
        // doc.line(10, startY+5, pageWidth - 10, startY+5); // Horizontal line below the header
        // doc.setFont("helvetica", "normal");

        // doc.text("Total Weight : "+ totalWeight, 160, startY + 12);
        // doc.text("Subtotal : $" + orderSubTotal, 160, startY + 19);
        // doc.text("Shipping : $" + delivery, 160, startY + 26);
        // doc.text("Total : $" + finalAmount, 160, startY + 33);

        const maxWidth = pageWidth - 20; // Page width minus total margin (10px on each side)

        doc.text("Note : " + textMessage, 10, startY + 20, { maxWidth });
        // Custom text after the table
        doc.setFontSize(8);

        // Calculate text width to center it
        const text1 = "Thank you for considering our products!";
        const textWidth1 = doc.getTextWidth(text1);
        const centerX1 = (pageWidth - textWidth1) / 2; // Center position

        doc.text(text1, centerX1, startY + 90); // Centered custom text

        // // Custom notes after the table
        // doc.setFontSize(8);
        // const text2 =
        //   "If you have any questions about this quotation, please contact us at websales@sejalgems.com.";
        // const textWidth2 = doc.getTextWidth(text2);
        // const centerX2 = (pageWidth - textWidth2) / 2; // Center position

        // doc.text(text2, centerX2, startY + 100); // Centered custom notes
        // setCartValue([]);
      };

      // Add Header
      addHeader();

      const newData = [
        {
          price: "Total",
          total_weight: totalWeight,
          updatedPrice: orderSubTotal,
        },
        { price: "Shipping", total_weight: "", updatedPrice: delivery },
        { price: "Net Total", total_weight: "", updatedPrice: finalAmount },
      ];
      const tableDataNew = [...cartValue, ...newData];

      // Extract headers and rows from the exportData
      const exportData = generateMappedArray(tableDataNew, column);
      const headers = column.map((col) => col.title); // Headers from column array
      const rows = exportData.map(
        (item) =>
          column.map((col) =>
            col.key === "price"
              ? item["price"]
              : col.key === "updatedPrice"
              ? item["updatedPrice"]
              : item[col.key]
          ) // Map the data to the keys in the column array
      );

      // Custom Design Before Table
      addCustomDesignBeforeTable();

      // Generate table in the PDF
      doc.autoTable({
        head: [headers], // Column headers
        body: rows, // Table rows
        startY: 70, // Start table after custom design
        styles: { fontSize: 10 },
        headStyles: {
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        margin: { top: 50, bottom: 30 },
        didDrawPage: (data) => {
          // Add Footer on each page after the table is drawn
          // addFooter();
          addHeader(); // Add header again if the table spans multiple pages
        },
      });

      // Custom Design After Table
      const finalY = doc.lastAutoTable.finalY; // Get the final y position of the table
      addCustomDesignAfterTable(finalY);

      // Download the PDF
      doc.save(
        selectedUserDetail.name.toLowerCase().replace(/ /g, "_") +
          "_quotation.pdf"
      );
      setLoading(false);
      // setIsModalOpen(false);
      // form.resetFields();
    } else {
      form.setFields([
        {
          name: "staff", // field name
          errors: ["Please select staff"], // error message
        },
        {
          name: "user",
          errors: ["Please select user"],
        },
      ]);
    }
  };

  const generateMappedArrayExcel = (data, columns) => {
    return data.map((row) => {
      let mappedRow = {};

      // Loop through each column definition
      columns.forEach((column) => {
        // Use the column's key to extract the corresponding data field
        mappedRow[column.title] = row[column.key];
      });

      return mappedRow;
    });
  };

  const exportExcel = () => {
    const data = form.getFieldsValue();

    if (data.user) {
      const workbook = XLSX.utils.book_new();
      const newData = [
        {
          price: "Total",
          total_weight: totalWeight,
          updatedPrice: orderSubTotal,
        },
        { price: "Shipping", total_weight: "", updatedPrice: delivery },
        { price: "Net Total", total_weight: "", updatedPrice: finalAmount },
      ];
      const tableDataNew = [...cartValue, ...newData];
      const exportData = generateMappedArrayExcel(tableDataNew, column);

      const worksheet = XLSX.utils.json_to_sheet(exportData);

      worksheet["!cols"] = [
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 13 },
        { wch: 10 },
        { wch: 10 },
      ];

      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      // Add bold styling for headers
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C }); // Cell in the first row
        if (!worksheet[cellAddress]) continue; // Skip if cell doesn't exist

        worksheet[cellAddress].s = {
          font: { bold: true },
        };
      }

      // Append rows for subtotal, shipping charge, and total
      const newRow = ["", ""];
      const subtotalRow = ["Note", textMessage];

      const existingData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Convert sheet to array
      const updatedData = [...existingData, [], newRow, subtotalRow]; // Append rows
      const updatedWorksheet = XLSX.utils.aoa_to_sheet(updatedData); // Convert array back to sheet

      XLSX.utils.book_append_sheet(
        workbook,
        updatedWorksheet,
        "Diamonds Quotation"
      );
      XLSX.writeFile(
        workbook,
        selectedUserDetail.name.toLowerCase().replace(/ /g, "_") +
          "_quotation.xlsx"
      );
    } else {
      form.setFields([
        {
          name: "staff", // field name
          errors: ["Please select staff"], // error message
        },
        {
          name: "user",
          errors: ["Please select user"],
        },
      ]);
    }
  };

  const generateMappedArray = (data, column) => {
    return data.map((item) =>
      column.reduce((acc, col) => {
        item.typeSelect === "Carat"
          ? (acc["updateCarat"] = item["updateCarat"])
          : (acc["updateCarat"] = item["updatePice"]);
        acc[col.key] = item[col.key];
        return acc;
      }, {})
    );
  };

  return (
    <>
      <Button
        className="oderfilter-serach-input bg-dark text-white"
        onClick={handleQuoate}
        icon={<FaCartShopping />}
      >
        Quotation
      </Button>

      <Modal
        title="Send Quotation"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        centered
        footer={false}
      >
        <Spin spinning={loading}>
          <Form layout="vertical" form={form} onFinish={onFinish}>
            <div className="row">
              <div className="col-12">
                {profile.type === "staff" ? (
                  ""
                ) : (
                  <Form.Item
                    rules={[{ required: true }]}
                    name="staff"
                    label="Select Staff"
                  >
                    <Select
                      showSearch
                      loading={loading}
                      placeholder="Select Staff"
                      onClick={() =>
                        setSearchData({ type: "staff", search: "" })
                      }
                      onSearch={(value) =>
                        setSearchData({ type: "staff", search: value })
                      }
                      onChange={(value) => setSelectedstaff(value)}
                    >
                      {staffList.map((value) => (
                        <Select.Option value={value.name}>
                          {value.name} ({value.number})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </div>
              <div className="col-12">
                <Form.Item
                  // rules={[{ required: true }]}
                  name="user"
                  label="Select User"
                >
                  <Select
                    showSearch
                    disabled={
                      profile.type === "staff" ? false : selectedStaff === ""
                    }
                    loading={loading}
                    placeholder="Select User"
                    onClick={() => setSearchData({ type: "user", search: "" })}
                    onSearch={(value) =>
                      setSearchData({ type: "user", search: value })
                    }
                    onChange={(userId) => {
                      const selectedUser = userList.find(
                        (user) => user.user_id === userId
                      ); // Find the user by comparing user_id
                      setSelectedUser(userId); // Set the user ID
                      setSelectedUserDetail(selectedUser); // Set the whole user object
                    }}
                  >
                    {userList.map((value) => (
                      <Select.Option
                        key={value.user_id}
                        value={value.user_id}
                        label={`${value.name} + (${value.number})`}
                      >
                        {value.name} ({value.number})
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-12">
                <Form.Item
                  rules={[{ required: true }]}
                  name="type"
                  label="Quote For"
                >
                  <Select placeholder="Select Quote For">
                    <Select.Option value="sent">Sent Only</Select.Option>
                    <Select.Option value="both">
                      Sent & Add to cart
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
              <div className="col-12">
                <Form.Item name="message" label="Message">
                  <TextArea
                    value={textMessage}
                    onChange={(e) => setTextMessage(e.target.value)}
                    showCount
                    placeholder="Message"
                  />
                </Form.Item>
              </div>
            </div>
          </Form>

          <div className="buttonGroup d-flex justify-content-between">
            <div className="downlaodButton">
              <Select
                value={downloadType}
                onChange={(val) => setDownloadType(val)}
                style={{ width: "80px" }}
                options={[
                  {
                    label: "PDF",
                    value: "pdf",
                  },
                  {
                    label: "Excel",
                    value: "excel",
                  },
                ]}
              />
              <Button
                className="oderfilter-serach-input bg-success text-white"
                onClick={downloadType === "pdf" ? exportPdf : exportExcel}
              >
                <MdDownload />
              </Button>
            </div>
            <div className="buttonList d-flex">
              <Button
                onClick={() => setIsModalOpen(false)}
                className="bg-danger text-white"
              >
                Cancel
              </Button>

              <Button
                className="bg-dark text-white"
                onClick={handleSubmitQuote}
              >
                Send <IoMdSend />
              </Button>
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}
